import { useQuery, useQueryClient } from '@tanstack/react-query';
import { api, ApiClientError, call } from './api';
import { getTape } from './music';

export type Me = Awaited<ReturnType<typeof fetchMe>>;

async function fetchMe() {
  return call(api.api.v1.me.$get());
}

/**
 * The signed-in user, or null when signed out. Email-not-verified and banned states surface as
 * errors with those codes.
 */
export function useMe() {
  return useQuery({
    queryKey: ['me'],
    queryFn: async () => {
      try {
        return await fetchMe();
      } catch (err) {
        if (err instanceof ApiClientError && err.status === 401) return null;
        throw err;
      }
    },
    staleTime: 60_000,
  });
}

export function usePublicConfig() {
  return useQuery({
    queryKey: ['config'],
    queryFn: () => call(api.api.config.$get()),
    // Refreshed now and then: the admin can change sign-ups and the announcement at runtime.
    staleTime: 5 * 60_000,
  });
}

export function useInvalidateMe() {
  const qc = useQueryClient();
  return () => qc.invalidateQueries({ queryKey: ['me'] });
}

/** The signed-in user's own mixtape (Side A / Side B). */
export function useTape() {
  return useQuery({ queryKey: ['tape'], queryFn: getTape });
}
